import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Svg1C = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon1-c';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zM6 9v.76h1.24V16h1.523l-.012-3.35L8.74 9.3l-.107-.228c-.122-.26-.392-.549-.624-.668-.236-.12-.591-.163-1.339-.164H6zm6.401-.716c-1.271.15-2.379 1.029-2.874 2.279-.198.5-.266.876-.263 1.457.005 1.099.389 2.006 1.161 2.742a3.5 3.5 0 0 0 1.555.886c.315.089.361.09 3.17.103l2.85.012V14.24h-2.753c-3.017 0-2.956.004-3.387-.242-.414-.236-.86-.799-1.008-1.274-.097-.313-.097-1.135 0-1.448.148-.474.568-1.006.999-1.267.443-.268 1.133-.323 1.638-.131.744.282 1.349 1.139 1.351 1.912V12h1.532l-.025-.318c-.143-1.855-1.568-3.301-3.367-3.415a4 4 0 0 0-.579.017"
    })
  }));
});
export default Svg1C;